module.exports = __webpack_public_path__ + "static/media/icons-nec.f98ea63a.svg";